import type { Me } from "./types";

let current: "hu" | "en" | null = null;

/** A bejelentkezett felhasználó nyelve a logó szlogenjéhez (a /api/me betöltésekor állítjuk). */
export function setLogoLang(me: Pick<Me, "locale"> | null | undefined) {
  current = me?.locale === "en" ? "en" : me?.locale === "hu" ? "hu" : null;
}

/** A logó nyelve: a felhasználó beállítása, belépés előtt a böngésző nyelve (magyar vagy angol). */
export function logoLang(): "hu" | "en" {
  if (current) return current;
  const nav = typeof navigator !== "undefined" ? navigator.languages?.[0] ?? navigator.language : "hu";
  return nav?.toLowerCase().startsWith("hu") ? "hu" : "en";
}
